<template>
  <div>
    <div class="textmobile-banner" style="display: block;">
      <van-image
        src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20230223/f1kzi4hptjrchah3ggxjuxe0.jpg?999"></van-image>
    </div>
    <div class="textmobile-content">
      <div id="test-editormd-view" class="markdown-body editormd-html-preview">
        <p>
          <a :href="wx_authorize_url">
            <van-image alt="" src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/cxyq/gytd.png"></van-image>
          </a>
          <router-link :to="{ path: 'order-list?orderType=movie' }">
            <van-image alt="" src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/cxyq/dydd.png"></van-image>
          </router-link>

          <router-link :to="{ path: 'topic-detail?topicId=16&buyFlag=1' }">
            <van-image alt="" src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/cxyq/spdh.png"></van-image>
          </router-link>
          <router-link :to="{ path: 'order-list?orderType=ticket' }">
            <van-image alt="" src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/cxyq/spdd.png"></van-image>
          </router-link>


          <router-link :to="{ path: 'user-cards' }">
            <van-image alt="" src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/cxyq/kj.png"></van-image>
          </router-link>


          <van-image alt="" src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/cxyq/sysm.png"
            @click="showPopup"></van-image>


          <a :href="$wx_kefu_rc()">
            <van-image alt=""
              src="https://rc-admin-1259573531.cos.ap-chengdu.myqcloud.com/online-service.jpg"></van-image>
          </a>
        </p>


        <p style="text-align: center;margin-top: 8px;display: block">
          <router-link :to="{ path: 'user-center-update-pwd' }"> 找回支付密码 </router-link>
        </p>
      </div>
    </div>

    <van-popup v-model="show" :style="{ height: '50%' }" bind:close="onClose" closeable position="bottom">
      <div style="text-align: center">
        <p style="font-weight: bold">川西北气矿工会职工观影卡</p>
        <div style="text-align: left;padding: 8px;">
          <p>微信使用:</p>
          <p>1.扫描卡券下方二维码，允许头像、昵称、地理位置申请，进入“川西北气矿工会职工幸福影院”主页；</p>
          <p>
            2.点击【卡券查询】→【绑定新卡券】→绑定手机号并自行设置6位数数字支付密码，输入卡号卡密或扫描本页二维码完成卡券绑定;</p>
          <p>
            3.进入“川西北气矿工会职工幸福影院”，点击菜单栏【专属观影通道】，选择城市，挑选影片，兑换时使用已绑定的卡券，完成兑换；</p>
          <p>4.点击菜单栏【视频会员兑换通道】选择心仪的商品，兑换时使用已绑定的卡券，完成兑换。</p>
          <p>5.如遇特殊原因无法兑换，请点击兑换通道首页【在线客服】或拨打客服电话4008750509。</p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { $wx_authorize_url } from "@/util/wxSdk"
import { $wx_kefu_rc } from "@/util/wxSdk"

export default {
  name: "cxyq",

  data() {
    return {
      show: false,
      wx_authorize_url: $wx_authorize_url("https://" + location.host + "/movie/")
    }
  },

  methods: {
    $wx_kefu_rc: $wx_kefu_rc,

    showPopup() {
      this.show = true;
    },

    forbidBack() {
      window.history.pushState('forward', null, '#');
      window.history.forward(1);
    },
  },

  mounted() {
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', this.forbidBack, false);
      this.forbidBack()
    }
  },

  destroyed() {
    window.removeEventListener('popstate', this.forbidBack, false);
  },
}
</script>

<style scoped>
.textmobile-banner {
  display: none;
  width: 100%;
}

.textmobile-banner img {
  max-width: 100%;
  display: block;
  margin: 0 auto;
}

.textmobile-content {
  padding: 8px;
}

.editormd-preview-container,
.editormd-html-preview {
  width: auto;
}
</style>
